export const RESET = "additionalServices/RESET"
export const SET_CATEGORY = "additionalServices/SET_CATEGORY"
export const SUBMIT = "additionalServices/SUBMIT"
export const SUBMIT_REQUEST = "additionalServices/SUBMIT_REQUEST"
export const SUBMIT_SUCCESS = "additionalServices/SUBMIT_SUCCESS"
export const SUBMIT_FAILURE = "additionalServices/SUBMIT_FAILURE"
